<template>
  <div class="d-flex align-items-center g-3">
    <ButtonView type="normal" color="secondary" size="small" @click="valueSelected(0)">
      {{ translate('today') }}
    </ButtonView>
    <ButtonView type="normal" color="secondary" size="small" @click="valueSelected(3)">
      {{ translate('lastXDays').replace(':days', 3) }}
    </ButtonView>
    <ButtonView type="normal" color="secondary" size="small" @click="valueSelected(7)">
      {{ translate('lastXDays').replace(':days', 7) }}
    </ButtonView>
    <ButtonView type="normal" color="secondary" size="small" @click="valueSelected(14)">
      {{ translate('lastXDays').replace(':days', 14) }}
    </ButtonView>
    <ButtonView type="normal" color="secondary" size="small" @click="valueSelected(30)">
      {{ translate('lastXDays').replace(':days', 30) }}
    </ButtonView>
    <div class="d-flex align-items-center">
      <DatePickerView :value="from" @update:value="$emit('update:from', transformFrom($event))" required :min="min" :max="to">
        <template v-slot:target="{ toggle }">
          <ButtonView type="normal" color="secondary" size="small" @click="toggle">
            {{ from ? utilities.formatDatetime(from) : "" }}
          </ButtonView>
        </template>
      </DatePickerView>
      <span class="fw-bold mx-2">-</span>
      <DatePickerView :value="to" @update:value="$emit('update:to', transformTo($event))" required :min="from" :max="currentDate.toISO()">
        <template v-slot:target="{ toggle }">
          <ButtonView type="normal" color="secondary" size="small" @click="toggle">
            {{ to ? utilities.formatDatetime(to) : "" }}
          </ButtonView>
        </template>
      </DatePickerView>
    </div>
  </div>
</template>

<script>
import {ButtonView, DatePickerView, utilities} from "@/niftybit";
import {DateTime} from "luxon";

export default {
  name: "HistoricDateRangePickerView",
  components: {ButtonView, DatePickerView},
  props: {
    from: String,
    to: String,
    min: String
  },
  emits: ["update:from", "update:to"],
  methods: {
    valueSelected(historyDays) {
      this.$emit("update:to", DateTime.utc().toLocal().minus({ days: historyDays > 0 ? 1 : 0 }).endOf("day").toISO());
      this.$emit("update:from", DateTime.utc().toLocal().minus({ days: historyDays }).startOf("day").toISO());
    },
    transformFrom(value) {
      return DateTime.fromISO(value).toLocal().startOf("day").toISO();
    },
    transformTo(value) {
      return DateTime.fromISO(value).toLocal().endOf("day").toISO();
    }
  },
  computed: {
    utilities() {
      return utilities
    },
    minDate() {
      return this.min ? DateTime.fromISO(this.min) : undefined;
    },
    currentDate() {
      return DateTime.utc().toLocal();
    }
  }
}
</script>

<style scoped>

</style>